function toast(message) {

    this.$toasted.show(message, {
        position: "top-center",
        duration: 5000,
        className: 'bg-primary',
        containerClass: 'vue-toasted',
        theme: "toasted-primary",
        singleton: true,
        action: {
            text: "OK",
            onClick: (e, toastObject) => {
            toastObject.goAway(0);
            }
        }
    });
}

function genericErrorMessage(){
    return 'Something went wrong!';
}


export { genericErrorMessage, toast }